<template>
  <transition
    v-if="visible"
    name="modal"
  >
    <div
      class="modal-mask"
    >
      <div
        class="modal-wrapper"
        @click.self="$emit('on-close')"
      >
        <div class="modal-container">
          <div class="modal-body">
            <slot name="body" />
          </div>
          <div class="modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import '../assets/styles/modal.css';

export default {
  name: 'Modal',
  props: {
    visible: Boolean,
  }
}
</script>